import type { App } from 'vue';

// 服务状态
export enum ServiceState {
  UNINITIALIZED = 'uninitialized',
  INITIALIZED = 'initialized',
  DESTROYED = 'destroyed',
}

// 基础服务接口
export interface IService {
  readonly name: string;
  readonly state: ServiceState;

  // 初始化服务
  initialize(app?: App): Promise<void>;

  // 销毁服务
  destroy(): Promise<void>;

  // 安装到 Vue 应用（可选）
  install?(app: App): void;
}

// 基础服务抽象类
export abstract class BaseService implements IService {
  public readonly name: string;
  protected _state: ServiceState = ServiceState.UNINITIALIZED;

  constructor(name: string) {
    this.name = name;
  }

  get state(): ServiceState {
    return this._state;
  }

  // 初始化服务
  async initialize(app?: App): Promise<void> {
    if (this._state === ServiceState.INITIALIZED) {
      return;
    }

    await this.onInitialize(app);
    this._state = ServiceState.INITIALIZED;
  }

  // 销毁服务
  async destroy(): Promise<void> {
    if (this._state === ServiceState.DESTROYED) {
      return;
    }

    await this.onDestroy();
    this._state = ServiceState.DESTROYED;
  }

  // 子类需要实现的抽象方法
  protected abstract onInitialize(app?: App): Promise<void>;
  protected abstract onDestroy(): Promise<void>;
}
